export const FETCH_LMS_SETTING_REQUEST = '@lmsSetting/FETCH_LMS_SETTING_REQUEST';
export const FETCH_LMS_SETTING_SUCCESS = '@lmsSetting/FETCH_LMS_SETTING_SUCCESS';
export const FETCH_LMS_SETTING_FAILURE = '@lmsSetting/FETCH_LMS_SETTING_FAILURE';

export const SET_DOWNLOAD_CONTENT = '@lmsSetting/SET_DOWNLOAD_CONTENT';
export const SET_LEARNER_DOWNLOAD_CONTENT = '@lmsSetting/SET_LEARNER_DOWNLOAD_CONTENT';
export const SET_SHOW_QUIZ_ANSWER = '@lmsSetting/SET_SHOW_QUIZ_ANSWER';
